import headlineModalContentTpl from '../templates/headline_modal_content.html';

function HeadlineModalInstanceController($scope, $modalInstance) {
  var vm = this;

  vm.cancel = function() {
    $modalInstance.close(false);
  };

  return vm;
}

HeadlineModalInstanceController.$inject = ['$scope', '$modalInstance'];

export default function HeadlineModalController($scope, $modal) {
  var vm = this;
  vm.open = function open(analysis) {
    vm.analysis = analysis;

    $modal.open({
      animation: true,
      template: headlineModalContentTpl,
      controller: HeadlineModalInstanceController,
      controllerAs: 'modalInstanceVm',
      scope: $scope,
      size: 'lg'
    });
  };

  vm.close = function close() {
    $modal.close();
  };

  return vm;
}

HeadlineModalController.$inject = ['$scope', '$modal'];
